module.exports = __webpack_public_path__ + "static/media/4.89a4bd5a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/4.gif
// module id = 67
// module chunks = 0